import { useQuery } from '@tanstack/vue-query';
import type { MaybeRef } from 'vue';

type ShareStats = {
  shares: number;
  leadsFromProject: number;
  pendingCommissionAed: number;
};

type ShareStatsResponse = {
  success: boolean;
  data: ShareStats;
};

export const usePropertyShareStatsQuery = (
  propertyId: MaybeRef<string | null | undefined>,
  enabled: MaybeRef<boolean> = true,
) => {
  const authStore = useAuthStore();

  return useQuery({
    queryKey: ['property-share-stats', computed(() => unref(propertyId) || '')],
    queryFn: () =>
      $fetch<ShareStatsResponse>(`/api/properties/${unref(propertyId)}/share/stats`, {
        headers: { Authorization: `Bearer ${authStore.token}` },
      }).then((r) => r.data),
    enabled: computed(() => !!authStore.token && !!unref(propertyId) && !!unref(enabled)),
    staleTime: 60 * 1000,
    retry: false,
  });
};
